import { Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import TextField from 'modules/core/components/TextField'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import i18n from 'modules/core/lib/i18n'

import settings from 'modules/complaints/store/collections/settings'

import { PrivacyPolicyForm } from './PrivacyPolicyForm'

export const PrivacyPolicy = observer(() => {
  useAsyncData(() => settings.fetch(), [])
  const setting = settings.current
  const form = useLazyRef(() => new PrivacyPolicyForm({})).current

  useEffect(() => {
    if (setting) {
      form.setValues(setting.toJS())
      form.cleanAll()
    }
  }, [!!setting]) // eslint-disable-line react-hooks/exhaustive-deps

  const { running, performAction: onSubmit } = useAsyncAction(
    async () => {
      if (!form.isDirty) return
      const custom_url = form.get('system_and_defense_custom_url').value
      await settings.upsert({
        system_and_defense_custom_url: custom_url,
      })
    },
    {
      successFlash: true,
      errorFlash: true,
    }
  )

  return (
    <Section.Form
      illustration="lock-user"
      title={i18n.t('app_store_v2.apps.complaints.settings.custom_informant_url.title')}
      description={i18n.t('app_store_v2.apps.complaints.settings.custom_informant_url.description')}
      onSubmit={onSubmit}
      isDirty={form.isDirty}
      submitLabel={i18n.t('common.submit')}
      disabled={!form.isValid || running}
    >
      <TextField
        type="text"
        label={i18n.t('app_store_v2.apps.complaints.settings.custom_informant_url.label')}
        value={form.get('system_and_defense_custom_url').value}
        onChange={(value) => form.setValues({ system_and_defense_custom_url: value })}
      />
    </Section.Form>
  )
})
